import { useParams } from 'react-router-dom'

import loginRequests from '@mediatool/mt-frontend/lib/login-requests'
import { getActivateUserData } from './get-activate-user-data'
import { getFormErrorsFromError } from './get-form-errors-from-error'
import { getFormErrorsFromFormValues } from './get-form-errors-from-form-values'

const initialValues = {
  firstName: '',
  lastName: '',
  password: '',
  jobTitle: undefined,
  jobTitleDescriptors: [],
  employedBy: 'brand',
  termsAccepted: false,
}

export function useActivateForm () {
  const { activationCode } = useParams()

  const onSubmit = (values, actions) => new Promise((resolve) => {
    const data = {
      user: getActivateUserData(values),
      password: values.password,
    }

    loginRequests.activate(activationCode, data)
      .fork(
        (error) => {
          getFormErrorsFromError(error).forEach((formError) => {
            actions.setError(formError.field, formError)
          })
          resolve()
        },
        () => {
          window.location = '/login'
          resolve()
        }
      )
  })
  return {
    initialValues,
    onSubmit,
    validate: getFormErrorsFromFormValues,
  }
}
